import React from "react";
import DefaultLogin from "./DefaultLogin";
import TermsAndAgreements from "./TermsAndAgreements";
import {useLoginInfoContext} from "./context/LoginInfoContext";

const LoginView = () => {
  const loginInfo = useLoginInfoContext();
  return (
    <>
      <DefaultLogin />
      {loginInfo.termsRequired && <TermsAndAgreements />}
    </>
  );
};

export default LoginView;
